import { VendorGetServerSideProps } from 'vendor/utils/VendorGetServerSideProps';
import { configureSSR } from 'src/utils/configureSSR';
import { fetchProductDetailsQuery } from 'src/modules/products/hooks/useProductDetailsQuery';
import { ProductPageProtocolsTemplate } from 'src/modules/products/templates/ProductPageProtocolsTemplate';
import { ProductDTO } from 'src/models/pim';

const ProtocolPage = ({ product }: { product: ProductDTO }) => (
  <ProductPageProtocolsTemplate {...product} />
);

export const getServerSideProps = VendorGetServerSideProps(async (ctx) => {
  const code = String(ctx.params?.code);

  const query = fetchProductDetailsQuery(ctx.apis, code);

  const product = await ctx.queryClient.fetchQuery(query);

  if (!product) {
    return {
      notFound: true,
    };
  }

  return configureSSR(ctx, {
    layout: {
      variant: 'default',
      tvbar: false,
    },
    cacheControl: {
      maxAge: 600,
      sMaxAge: 1200,
    },
    actions: {
      common: () => [ctx.queryClient.setQueryData(query.queryKey, product)],
    },
    return: {
      props: { product },
    },
  });
});

export default ProtocolPage;
